import React from 'react'
import { VerticalTimelineElement } from 'react-vertical-timeline-component'

const ExprienceCard = ({ exprience }) => {
  return (
    <VerticalTimelineElement
      contentStyle={{
        background: '#1d1836',
        color: '#915eff',
        borderRadius: '10px',
      }}
      contentArrowStyle={{ borderRight: '7px solid #232631' }}
      date={exprience.date}
      iconStyle={{ background: exprience.iconBg }}
      icon={
        <section className='flex justify-center items-center w-full h-full'>
          <img
            src={exprience.icon}
            alt={exprience.company_name}
            className='w-[70%] h-[70%] object-contain'
          />
        </section>
      }
    >
      <div className='bg-white dark:bg-transparent rounded-md shadow-md dark:shadow-none shadow-primary_color p-2'>
        <div className=''>
          <h3 className='dark:text-white text-[24px] font-bold text-[#915eff]'>
            {exprience.title}
          </h3>
          <p className='dark:text-secondary text-[16px] font-semibold m-0 text-primary'>
            {exprience.company_name}
          </p>
        </div>
        <ul className='mt-5 list-disc ml-5 space-y-2 '>
          {exprience.points.map((point, index) => (
            <li
              className='dark:text-white text-gray-500 pl-1 text-[14px] tracking-wider'
              key={index}
            >
              {point}
            </li>
          ))}
        </ul>
      </div>
    </VerticalTimelineElement>
  )
}

export default ExprienceCard
